import React, { useEffect, useState } from "react";
import { MessageCircle, X } from "lucide-react";

const PHONE = "918018911999";  // country code + number, no +
const DEFAULT_MSG = "Hi HomeTheatres India, I'd like to learn more about your home theatre systems.";

export default function WhatsappFab() {
  const [expanded, setExpanded] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  // Show a small greeting bubble briefly on first visit (session)
  useEffect(() => {
    if (sessionStorage.getItem("wa-hint-seen")) return;
    const t = setTimeout(() => setExpanded(true), 3500);
    const off = setTimeout(() => {
      setExpanded(false);
      sessionStorage.setItem("wa-hint-seen", "1");
    }, 11000);
    return () => { clearTimeout(t); clearTimeout(off); };
  }, []);

  if (dismissed) return null;

  const href = `https://wa.me/${PHONE}?text=${encodeURIComponent(DEFAULT_MSG)}`;

  return (
    <div className="fixed z-[60] bottom-5 right-5 md:bottom-8 md:right-8 flex flex-col items-end gap-3" data-testid="wa-fab-root">
      {expanded && (
        <div className="max-w-xs rounded-2xl shadow-2xl overflow-hidden animate-fade-in-up" style={{ background: "#FDFBF6", border: "1px solid rgba(15,12,8,0.12)" }} data-testid="wa-hint">
          <div className="flex items-center justify-between gap-2 px-4 py-2.5" style={{ background: "#25D366", color: "#fff" }}>
            <div className="text-[11px] uppercase tracking-[0.2em] font-semibold flex items-center gap-2">
              <MessageCircle className="w-3.5 h-3.5" /> HomeTheatres India
            </div>
            <button onClick={(e) => { e.stopPropagation(); setExpanded(false); sessionStorage.setItem("wa-hint-seen", "1"); }} className="opacity-80 hover:opacity-100" aria-label="Close" data-testid="wa-hint-close">
              <X className="w-3.5 h-3.5" />
            </button>
          </div>
          <a href={href} target="_blank" rel="noopener noreferrer" className="block px-4 py-3.5" data-testid="wa-hint-open">
            <div className="text-sm leading-snug" style={{ color: "var(--ink)", fontFamily: "'Manrope', sans-serif" }}>
              Hi 👋 Have a question about a system, brand or installation? <span className="font-semibold">Chat with us</span> — we usually reply within minutes.
            </div>
            <div className="mt-3 text-[10px] uppercase tracking-[0.22em] font-semibold" style={{ color: "#128C7E", fontFamily: "'JetBrains Mono', monospace" }}>Open WhatsApp →</div>
          </a>
        </div>
      )}

      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => sessionStorage.setItem("wa-hint-seen", "1")}
        aria-label="Chat on WhatsApp"
        data-testid="wa-fab"
        className="group relative flex items-center justify-center rounded-full transition-all duration-500 hover:-translate-y-1"
        style={{
          width: 60, height: 60,
          background: "#25D366",
          boxShadow: "0 1px 0 rgba(255,255,255,0.35) inset, 0 -1px 0 rgba(0,0,0,0.15) inset, 0 12px 28px -8px rgba(37,211,102,0.55), 0 4px 8px rgba(37,211,102,0.25)",
        }}
      >
        {/* Ping pulse */}
        <span className="absolute inset-0 rounded-full animate-ping opacity-60" style={{ background: "#25D366", animationDuration: "2.5s" }}></span>
        {/* WhatsApp logomark (SVG) */}
        <svg viewBox="0 0 24 24" fill="#FFFFFF" className="w-7 h-7 relative z-10" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M20.52 3.48A11.83 11.83 0 0 0 12.05 0C5.5 0 .2 5.3.2 11.86c0 2.09.55 4.13 1.6 5.94L0 24l6.36-1.67a11.85 11.85 0 0 0 5.68 1.45h.01c6.55 0 11.86-5.3 11.86-11.86 0-3.17-1.24-6.15-3.39-8.44Zm-8.47 18.24h-.01a9.85 9.85 0 0 1-5.02-1.38l-.36-.21-3.77.99 1-3.68-.23-.38a9.83 9.83 0 0 1-1.51-5.2c0-5.44 4.43-9.87 9.88-9.87 2.64 0 5.12 1.03 6.98 2.9a9.8 9.8 0 0 1 2.89 6.98c0 5.45-4.43 9.87-9.85 9.87Zm5.41-7.4c-.3-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.66.15s-.76.95-.93 1.15c-.17.2-.34.22-.63.07-.3-.15-1.25-.46-2.38-1.47a8.9 8.9 0 0 1-1.65-2.05c-.17-.3-.02-.46.13-.61.13-.13.3-.34.44-.51.15-.17.2-.29.3-.49.1-.2.05-.37-.02-.52-.07-.15-.66-1.6-.9-2.19-.24-.57-.48-.5-.66-.51l-.56-.01c-.2 0-.51.07-.78.37-.27.3-1.02 1-1.02 2.43 0 1.44 1.05 2.83 1.2 3.02.15.2 2.06 3.15 5 4.42.7.3 1.25.48 1.67.62.7.22 1.34.19 1.85.11.56-.08 1.75-.71 2-1.4.25-.7.25-1.29.17-1.4-.07-.13-.27-.2-.56-.35Z"/>
        </svg>
      </a>
    </div>
  );
}
